import { ToastMessageStyleInterface } from "./toast_message_style_interface";

export const toastMessageDefaultStyle: ToastMessageStyleInterface = {
    backgroundColor: "white",
    textColor: "primary",
    shadow: "shadow hover:shadow-dark",
    iconColor: "primary",
    iconCloseColor: "grey-dark",
};
